import React from 'react'
import PropTypes from 'prop-types'
import {Box, Image} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'

const ResponsiveImage = ({
    alt,
    imagelg, // image > 1024px
    imagemd, // image > 768px
    imagesm, // image < 475px
    imageSmallTablet, // image > 475px && < 767px
    height = '100%',
    width = '100%',
    objectFit = 'cover',
    imageProps,
    ...props
}) => {
    const imageSrc = imagesm || imagemd || imagelg || imageSmallTablet

    return (
        <Box position="relative" width={width} height={height} {...props}>
            <picture>
                {imagelg && <source media={`(min-width:${remCalc(1024)})`} srcSet={imagelg} />}
                {imagemd && <source media={`(min-width:${remCalc(768)})`} srcSet={imagemd} />}
                {imageSmallTablet && (
                    <source
                        media={`(min-width: ${remCalc(475)}) and (max-width: ${remCalc(767)})`}
                        srcSet={imageSmallTablet}
                    />
                )}
                <Image
                    src={imageSrc}
                    alt={alt}
                    loading="lazy"
                    width="100%"
                    height="auto"
                    objectFit={objectFit}
                    {...imageProps}
                />
            </picture>
        </Box>
    )
}

ResponsiveImage.propTypes = {
    alt: PropTypes.string,
    imagelg: PropTypes.string,
    imagemd: PropTypes.string,
    imagesm: PropTypes.string,
    imageSmallTablet: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string,
    objectFit: PropTypes.string,
    imageProps: PropTypes.object,
}

export default ResponsiveImage
